import type {
  FilterConditionDto,
} from '@bindoc-projects/condition-domain-lib';
import {
  BdCondition
} from '@bindoc-projects/condition-domain-lib';

import type {
  FilterConditionPluginSpecification,
} from '@bindoc-projects/filter-condition-domain-lib';
import {
  FilterConditionPluginImpl
} from '@bindoc-projects/filter-condition-domain-lib';

export const BD_GASTPATIENTEN_AT_CONDITION_ID = 'gastpatientenAT';
export const FilterConditionGastpatientenAtPluginType: FilterConditionPluginSpecification<
  boolean,
  FilterConditionGastpatientenAtDto,
  BdGastpatientenAtCondition
> = {
  type: 'gastpatientenAT',
  category: 'case',
  displayName: { de: 'Gastpatienten' },
  sortingIndex: 8,
  occurrence: 'multiple',
  fromObject(
    obj: FilterConditionGastpatientenAtDto,
  ): FilterConditionPluginImpl<boolean> {
    return new FilterConditionGastpatientenAtPlugin(obj.flag);
  },
  fromCondition(
    jsonObj: BdGastpatientenAtCondition,
  ): FilterConditionPluginImpl<boolean> {
    return new FilterConditionGastpatientenAtPlugin(jsonObj.flag);
  },
  newInstance(): FilterConditionPluginImpl<boolean> {
    return new FilterConditionGastpatientenAtPlugin(true);
  },
};

export class FilterConditionGastpatientenAtPlugin extends FilterConditionPluginImpl<
  boolean,
  FilterConditionGastpatientenAtDto
> {
  static override Specification: FilterConditionPluginSpecification<
    boolean,
    FilterConditionGastpatientenAtDto,
    BdGastpatientenAtCondition
  > = FilterConditionGastpatientenAtPluginType;

  constructor(private _flag: boolean) {
    super(FilterConditionGastpatientenAtPluginType.type);
  }

  toCondition(): BdCondition {
    return new BdGastpatientenAtCondition(this._flag);
  }

  toJSON(): FilterConditionGastpatientenAtDto | null {
    return {
      type: this.type,
      flag: this._flag,
    };
  }

  toText(): string | null {
    return 'Gastpatienten';
  }

  toValue(): boolean {
    return this._flag;
  }

  override equals(other: FilterConditionGastpatientenAtPlugin): boolean {
    return super.equals(other) && this._flag === other._flag;
  }

  override valid(): boolean {
    return this._flag !== null && this._flag !== undefined;
  }

  override validationToText(): string {
    if (this.valid()) {
      return '';
    } else {
      return 'Ja/Nein auswählen';
    }
  }

  clone(): FilterConditionGastpatientenAtPlugin {
    return new FilterConditionGastpatientenAtPlugin(this._flag);
  }
}

export class BdGastpatientenAtCondition extends BdCondition {
  constructor(public flag: boolean) {
    super(BD_GASTPATIENTEN_AT_CONDITION_ID);
  }

  toJSON(): FilterConditionDto {
    return {
      [this.id]: {
        flag: this.flag,
      },
    };
  }
}

interface FilterConditionGastpatientenAtDto {
  type: string;
  flag: boolean;
}
